<template>
  <div>
    <el-tag size="large">{{ copyrightMap[type] }}</el-tag>
    <br>
    <br>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane :label="getTabLabel(index)" :name="`${index}`" v-for="(item, index) in copyrights" :key="index"></el-tab-pane>
    </el-tabs>
    <el-form
      ref="form"
      :model="form"
      :rules="isMatchCurrent ? rules : {}"
      label-width="110px"
      :disabled="disabled"
      :validate-on-rule-change="false"
    >
      <el-tag v-if="isMatchCurrent">{{ match.isTme ? 'TME' : '生态' }}</el-tag>
      <el-form-item label="合同编号" prop="contract" :class="{'diff': diffKeys.includes('contract') }">
        <el-input
          v-model="form.contract"
          placeholder="请输入合同编号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="可否转授权"
        prop="canAuth"
        :class="{'diff': diffKeys.includes('canAuth') }"
      >
        <el-radio-group v-model="form.canAuth">
          <el-radio v-for="(name, id) in canAuthMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="海外总代理" prop="isOverseaOnly" :class="{'diff': diffKeys.includes('isOverseaOnly') }">
        <el-radio-group v-model="form.isOverseaOnly">
          <el-radio v-for="(name, id) in isOverseaMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="版权来源" prop="cpSource" :class="{'diff': diffKeys.includes('cpSource') }">
        <el-select
          v-model="form.cpSource"
          placeholder="请选择版权来源"
        >
          <el-option
            v-for="(name, id) in cpSourceMap"
            :key="id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可维权" prop="canLegalRights">
        <el-radio-group v-model="form.canLegalRights">
          <el-radio v-for="(name, id) in canLegalRightsMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="授权区域" prop="copyrightArea" :class="{'diff': diffKeys.includes('copyrightArea') }">
        <el-select
          v-model="form.copyrightArea"
          multiple
          filterable
        >
          <el-option
            v-for="(name, id) in copyrightAreaMap"
            :key="id"
            :data-key="id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="授权开始时间" prop="copyrightFrom" :class="{'diff': diffKeys.includes('copyrightFrom') }">
        <el-date-picker
          v-model="form.copyrightFrom"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="field"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="授权结束时间" prop="copyrightTo" :class="{'diff': diffKeys.includes('copyrightTo') }">
        <el-date-picker
          v-model="form.copyrightTo"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="field"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="是否可翻唱" prop="canCover" :class="{'diff': diffKeys.includes('canCover') }" v-if="type !== COPYRIGHT_TYPE.TRACK">
        <el-select v-model="form.canCover" clearable>
          <el-option
            v-for="(name, key) in canCoverMap"
            :key="key"
            :label="key + '. ' + name"
            :value="+key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="签约类型" prop="contractType" v-if="type !== COPYRIGHT_TYPE.TRACK" :class="{'diff': diffKeys.includes('contractType') }">
        <el-select v-model="form.contractType" placeholder="">
          <el-option v-for="(name, key) in contractTypeMap" :key="key" :label="name" :value="+key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="授权份额" prop="cpPercent" v-if="type !== COPYRIGHT_TYPE.TRACK" :class="{'diff': diffKeys.includes('cpPercent') }">
        <el-input-number
          v-model.trim="form.cpPercent"
          :controls="false"
          :max="100"
          :min="0"
          placeholder="请输入授权份额"
        ></el-input-number>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { copyrightAreaMap, canAuthMap } from '@/utils/constants'
import {
  cpSourceMap, isOverseaMap, canCoverMap, contractTypeMap,
  canLegalRightsMap
} from '@/views/album/mixin.js'
import { cloneDeep } from 'lodash-es'
import { COPYRIGHT_TYPE, CopyrightFormModal } from '../const'
import { copyrightMap } from '../../const'

export default {
  name: 'Copyright',

  props: {
    type: {
      type: String,
      default: COPYRIGHT_TYPE.TRACK
    },
    editing: {
      type: Boolean,
      default: false,
    },
    match: {
      type: Object,
    },
    list: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      copyrights: [],

      copyrightMap,
      cpSourceMap,
      isOverseaMap,
      copyrightAreaMap,
      canAuthMap,
      canCoverMap,
      contractTypeMap,
      canLegalRightsMap,
      COPYRIGHT_TYPE,

      activeName: '0',
      isNewCopyright: false,

      form: new CopyrightFormModal(this.type),

      matchIndex: -1,

      rules: {
        contract: {
          required: true,
          message: '请输入合同编号',
          trigger: 'blur'
        },
        copyrightArea: {
          required: true,
          type:
           'array',
          message: '请选择授权区域',
          trigger: 'change'
        },
        copyrightFrom: {
          required: true,
          type: 'string',
          message: '请选择授权开始时间',
          trigger: 'change'
        },
        copyrightTo: {
          required: true,
          type: 'string',
          message: '请选择授权结束时间',
          trigger: 'change',
        },
        contractType: {
          required: true,
          type: 'number',
          message: '请选择签约类型',
          trigger: 'change'
        },
        cpPercent: {
          required: true,
          type: 'number',
          message: '请填写授权份额',
          trigger: 'blur'
        },
        cpSource: {
          required: true,
          type: 'number',
          message: '请选择版权来源',
          trigger: 'change'
        }
      },

      cachedForm: null
    }
  },

  computed: {
    diffKeys() {
      if (!this.isMatchCurrent || this.isNewCopyright) {
        return []
      }

      const copyright = this.copyrights[this.activeName]
      const keys = Object.keys(this.form)
      const diffKeys = keys.filter(key => {
        if (key === 'copyrightArea') {
          return this.form[key].join(',') === copyright[key]
        }
        return copyright[key] !== this.form[key]
      })
      return diffKeys
    },

    disabled() {
      return !this.isMatchCurrent || !this.editing
    },

    isMatchCurrent() {
      return +this.activeName === this.matchIndex
    }
  },

  watch: {
    activeName(newVal, oldVal) {
      this.handleSave(oldVal)
      this.setForm()
    }
  },

  async mounted() {
    if (this.match) {
      const matchItem = this.list.find(item => {
        return item.cpCompany &&
        this.match.cpCompany &&
        item.cpCompany.companyId === this.match.cpCompany.companyId
      })
      this.copyrights = cloneDeep(!matchItem ? [...this.list, this.match] : this.list)
      this.isNewCopyright = !matchItem

      this.setActive()
    } else {
      this.copyrights = cloneDeep(this.list)
    }

    this.setForm()
  },

  methods: {
    async getData() {
      if (!this.match) {
        return null
      }

      if (+this.activeName !== this.matchIndex) {
        this.activeName = `${this.matchIndex}`
        this.setForm()
      }

      await new Promise((resolve) => this.$nextTick(resolve))
      await this.$refs.form.validate()

      return {
        ...this.match,
        ...this.form,
        cpSource: +this.form.cpSource,
        copyrightArea: this.form.copyrightArea.join(',')
      }
    },

    getTabLabel(index) {
      const match = index === this.matchIndex
      const text = this.isNewCopyright ? '(新增)' : '(修改)'
      return `版权${index + 1}${match ? text : ''}`
    },

    setActive() {
      this.copyrights.forEach((copyright, index) => {
        if (
          copyright.cpCompany &&
          this.match.cpCompany &&
          copyright.cpCompany.companyId === this.match.cpCompany.companyId
        ) {
          this.activeName = `${index}`

          this.matchIndex = index
        }
      })
    },

    setForm() {
      if (this.cachedForm && this.isMatchCurrent) {
        this.form = { ...this.cachedForm }
        return
      }

      const current = this.match && this.isMatchCurrent
        ? this.match
        : this.copyrights[this.activeName]

      let ext = {}

      if (this.type !== COPYRIGHT_TYPE.TRACK) {
        ext = {
          cpPercent: current.cpPercent,
          contractType: current.contractType,
          canCover: current.canCover
        }
      }

      this.form = {
        ...ext,
        canAuth: current.canAuth,
        contract: current.copyright && current.copyright.contract,
        canLegalRights: current.canLegalRights,
        cpSource: current.cpSource === 0 ? '' : current.cpSource,
        isOverseaOnly: current.isOverseaOnly,
        copyrightArea: current.copyrightArea ? current.copyrightArea.split(',').map(Number) : [],
        copyrightFrom: current.copyrightFrom,
        copyrightTo: current.copyrightTo,
      }

      this.$refs.form.clearValidate()
    },

    handleSave(tabIndex) {
      if (+tabIndex !== this.matchIndex) {
        return
      }
      this.cachedForm = { ...this.form }
    },
  }

}
</script>

<style lang="scss" scoped>
.diff > {
  ::v-deep {
    label {
      color: #F56C6C !important
    }
  }
}

.field {
  width: 176px;
}
</style>
